"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconInfoOutline = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var IconInfoOutline = function IconInfoOutline(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z M12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 C17.5228475,22 22,17.5228475 22,12 C22,6.4771525 17.5228475,2 12,2 Z M12.75,9.57675781 C13.2141016,9.84845969 13.5,10.3505855 13.5,10.8939892 L13.5,16.9780203 C13.5,17.5223959 13.2141016,18.0245217 12.75,18.2962236 C12.2858984,18.5679255 11.7141016,18.5679255 11.25,18.2962236 C10.7858984,18.0245217 10.5,17.5223959 10.5,16.9789922 L10.5,10.8939892 C10.5,10.3505855 10.7858984,9.84845969 11.25,9.57675781 C11.7141016,9.30505593 12.2858984,9.30505593 12.75,9.57675781 Z M11.9904153,5.5 C12.8722045,5.5 13.4309904,6.10257177 13.4492013,6.90535287 C13.4492013,7.67217404 12.8741214,8.29223982 11.9731629,8.29223982 C11.1086262,8.29223982 10.5325879,7.67217404 10.5507987,6.90535287 C10.5325879,6.10257177 11.1086262,5.5 11.9904153,5.5 Z",
    id: "Shape"
  }));
};
exports.IconInfoOutline = IconInfoOutline;